import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { aboutSaveProfile, fetchCities, fetchCountry, fetchState, updateCandidateDetails } from '../AboutYou/AboutYouAPI';

const initialState = {
  value: 0,
  country: [],
  state: [],
  cities: [],
  aboutDetails: {},
  aboutResponse: {},
  status: 'idle',
};

export const fetchCountryAsync = createAsyncThunk(
  "candidate/country",
  async () => {
    try {
      const response = await fetchCountry();
      // console.log("country response:", response);
      return response;
    } catch (error) {
      console.log("Error in making the fetch request to API:", error);
    }
  }
);
export const fetchStateAsync = createAsyncThunk(
  "candidate/state",
  async (uuid) => {
    // console.log("id:- ", id);
    try {
      const response = await fetchState(uuid);
      // console.log("state response:", response.response);
      return response;
    } catch (error) {
      console.log("Error in making the fetch request to API:", error);
    }
  }
);
export const fetchCitiesAsync = createAsyncThunk(
  "candidate/cities",
  async (uuid) => {
    // console.log("id: cities:- ", id);
    try {
      const response = await fetchCities(uuid);
      // console.log("city response:", response.response);
      return response;
    } catch (error) {
      console.log("Error in making the fetch request to API:", error);
    }
  }
);

// export const fetchCandidateDetailsAsync = createAsyncThunk(
//   "candidate/details",
//   async () => {
//     try {
//       const response = await fetchCandidateDetails();
//       // console.log("candidate response:", response);
//       return response;
//     } catch (error) {
//       console.log("Error in making the fetch request to API:", error);
//     }
//   }
// );

export const aboutSaveDetailsAsync = createAsyncThunk(
  "candidate/aboutSaveDetails",
  async ({ data }) => {
    try {
      const response = await aboutSaveProfile({ data });
      
      return response.response;
    } catch (error) {
      console.log("Error in making the aboutSaveProfile:", error);
    }
  }
);




export const aboutYouSlice = createSlice({
  name: 'aboutYou',
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(fetchCountryAsync.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchCountryAsync.fulfilled, (state, action) => {
        state.status = "idle";
        state.country = action.payload.response;
      })
      .addCase(fetchStateAsync.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchStateAsync.fulfilled, (state, action) => {
        state.status = "idle";
        state.state = action.payload.response;
      })
      .addCase(fetchCitiesAsync.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchCitiesAsync.fulfilled, (state, action) => {
        state.status = "idle";
        state.cities = action.payload.response;
      })
      // .addCase(fetchCandidateDetailsAsync.pending, (state) => {
      //   state.status = "loading";
      // })
      // .addCase(fetchCandidateDetailsAsync.fulfilled, (state, action) => {
      //   state.status = "idle";
      //   state.cities = action.payload.response;
      // })
      .addCase(aboutSaveDetailsAsync.pending, (state) => {
        state.status = "loading";
      })
      .addCase(aboutSaveDetailsAsync.fulfilled, (state, action) => {
        state.status = "idle";
        state.aboutResponse = action.payload;
      })

  },
});

export const selectFetchCountry = (state) => state.aboutYou.country;
export const selectFetchState = (state) => state.aboutYou.state;
export const selectFetchCities = (state) => state.aboutYou.cities;
export const selectCandidateDetails = (state) => state.aboutYou;
export const selectAboutResponse = (state) => state.aboutYou.aboutResponse;

export default aboutYouSlice.reducer;
